// Local-first "skip onboarding" state, keyed by user id. When set, the agent's
// onboarding nudge stops leading the empty state and the panel advances to page
// / discovery suggestions. The remaining steps still live in the command
// palette's "Finish setup" group until they are actually complete. A later
// version can move this to a durable backend flag (SWC-19458).

import { notifyAgentStateChanged } from 'entities/WebMcp/lib/agentStateSignal'

const storageKey = (userId: string | number): string => `webmcp.onboardingSkipped.${userId}`

export const isOnboardingSkipped = (userId?: string | number | null): boolean => {
  if (userId === null || userId === undefined) return false
  try {
    return localStorage.getItem(storageKey(userId)) === '1'
  } catch {
    return false
  }
}

export const markOnboardingSkipped = (userId?: string | number | null): void => {
  if (userId === null || userId === undefined) return
  try {
    localStorage.setItem(storageKey(userId), '1')
    notifyAgentStateChanged()
  } catch {
    // Ignore write failures — the nudge simply reappears next load.
  }
}
